export default "__VITE_ASSET__BiMry3Ls__"